<div class="store-type-container">
    <div class="store-type-container__header header">
        <div class="header__title" [translate]="'select-store-type.title'"></div>
        <div class="header__desc" [translate]="'select-store-type.description'"></div>
    </div>
    <div class="store-type-container__content content">
        <div id=" createPhysicalStore" class="item create-physical-big content__action-card action-card">
            <div class="action-card__img-container">
                <img src="/assets/images/stores/physical-store.png" class="action-card__img">
            </div>
            <div class="action-card__action-body">
                <div class="action-card__action-title" [translate]="'select-store-type.physical-store-title'">
                </div>
                <div class="text-left description action-card__action-desc" [translate]="'select-store-type.physical-store-description'">
                </div>
                <button class="btn btn-primary action-card__button" type="button" (click)="selectStore(false)"
                    [translate]="'select-store-type.physical-store-button'" data-test="create-phisical-store"></button>
            </div>
        </div>
        <div id="createOnlineStore" class="item create-online-big content__action-card action-card">
            <div class="action-card__img-container">
                <img src="/assets/images/stores/online-store.png" class="action-card__img">
            </div>

            <div class="action-card__action-body">
                <div class="action-card__action-title" [translate]="'select-store-type.online-store-title'">
                </div>
                <div class="text-left description action-card__action-desc" [translate]="'select-store-type.online-store-description'">
                </div>

                <button class="btn btn-primary action-card__button action-card__button" type="button" (click)="selectStore(true)"
                    [translate]="'select-store-type.online-store-button'" data-test="create-online-store"></button>

            </div>
        </div>
    </div>
</div>
